import { useEffect } from "react";
import { Form } from "antd";
import { useAtom } from "jotai";
import { frmPreguntasCalidadTrabajoAtom, puntajeTotalCalidadTrabajoAtom } from "../../BandejaEvaluacionStorage";

const usePreguntasCalidadTrabajo = () => {
	const [puntajeTotal, setPuntajeTotal] = useAtom(puntajeTotalCalidadTrabajoAtom);
	const [frmPreguntas, setFrmPreguntas] = useAtom(frmPreguntasCalidadTrabajoAtom);
	const [form] = Form.useForm();

	useEffect(() => {
		if (!frmPreguntas) {
			setFrmPreguntas(form);
		}
	}, []);

	return { frmPreguntas, puntajeTotal, setPuntajeTotal };
};

export default usePreguntasCalidadTrabajo;
